import { useContext } from 'react';
import { Outlet } from 'react-router-dom';
import ClipLoader from 'react-spinners/ClipLoader';
import NavbarComponent from '../../components/common/navbar/NavbarComponent';
import { userContext } from '../../context/UserContext';
function LayoutPage() {
    const { loading, user } = useContext(userContext); // Use the UserContext



    if (loading) {
        return (
            <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
                <ClipLoader color="#3498db" loading={loading} size={50} />
            </div>
        );
    }
    return (
        <>
            <div className="layout-container">
                <NavbarComponent >
                    <Outlet />
                </NavbarComponent>
            </div>
        </>
    )
}

export default LayoutPage